import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useNavMenuDesktopItemStyles = makeStyles<Theme, { hideBottomBorder?: boolean; isSelected?: boolean }>(
  () => ({
    menuItemsDesktop__button: {
      boxShadow: 'none!important',
      background({ isSelected }) {
        return isSelected ? 'hsla(0,0%,100%,.1)' : 'none';
      },
      color: 'white!important',
      '&.active': {
        background: 'hsla(0,0%,100%,.1)'
      },
      '&:hover': {
        background: 'hsla(0,0%,100%,.1)'
      },
      '&:last-child': {
        marginRight: 0
      },
      marginRight: '0.5rem'
    }
  })
);
